export const SET_LOAD_PROMOTIONS_STATE = 'SET_LOAD_PROMOTIONS_STATE';

export default function setLoadPromotions(payload) {
  return {
    type: SET_LOAD_PROMOTIONS_STATE,
    payload,
  };
}
